import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'indonesia_does_fac_comply_legal_req_concerning_outsourced'

export const dataPointDefinition = {
  retracedId: 'indonesia_does_fac_comply_legal_req_concerning_outsourced',
  name: 'Indonesia: Does the facility comply with legal requirements concerning outsourced workers at the workplace?',
  description:
    'This question is specific to Indonesia only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-11',
      number: 'RH-EMP-25',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-11', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34400,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
